module.exports = __webpack_public_path__ + "media/images/pedestal-logo-702e00e6a406753fa69030a4cb478fed.png";